module.exports = __webpack_public_path__ + "static/media/logo-color-dark.e2c9fdd2.svg";